/**
 * Hotel Introduction on deal page
 */
export class HotelIntroComponent {

    /**
     * @param fullHeight {number}
     */
    constructor(height) {
        this.isVisible = false;
        this.height = height;
        this.container = undefined;
        this.minHeight = undefined;
        this.showMoreAbout = undefined;
        this.aboutText = undefined;
        this.init();
    }

    /**
     * Get the visibility info of the container
     * @return {boolean}
     */
    getIsVisible() {
        return this.isVisible;
    }

    /**
     * Get the height value of the container
     * @return {number}
     */
    getHeight() {
        return this.height;
    }

    /**
     * Set the visibility of the container
     * @param visibility
     */
    setVisibility(visibility) {
        if (typeof visibility !== 'boolean') {
            throw {error: 'Visibility must be a boolean'};
        }
        this.isVisible = visibility;
    }

    /**
     * Returns the minimum value of the container
     * @return {*}
     */
    getMinHeight() {
        if (typeof this.minHeight === 'undefined') {
            this.minHeight = 220;
        }
        return this.minHeight;
    }

    /**
     * Returns the introduction text box
     * @return {*}
     */
    getContainer() {
        if (typeof this.container === 'undefined') {
            this.container = $('#aboutTextContainer');
        }

        return this.container;
    }

    /**
     * Returns the the text box element
     */
    getTextBox() {
        if (typeof this.aboutText === 'undefined') {
            this.aboutText = $('#aboutText');
        }

        return this.aboutText;
    }

    getShowMoreAbout() {
        if (typeof this.showMoreAbout === 'undefined') {
            this.showMoreAbout = this.getContainer().find('.show-more-about');
        }

        if (this.showMoreAbout.length === 0) {
            throw {element: '.show-more-about', reason: 'not found'};
        }

        return this.showMoreAbout;
    }

    init() {
        this.initContainer();
        this.initMoreAbout();
    }

    /**
     * Initialize the container default state
     */
    initContainer() {
        if (this.getHeight() > this.getMinHeight()) {
            this.getTextBox().height(this.getMinHeight());
        } else {
            this.getShowMoreAbout().addClass('d-none');
        }
    }

    /**
     * Initialize the "Show more/less" button
     */
    initMoreAbout() {
        const showMoreAbout = this.getContainer().find('.show-more-about');
        this.getContainer()
            .find('.more-about-link')
            .on('click.moreAbout', (event) => {
                event.preventDefault();

                if (this.getIsVisible()) {
                    this.getTextBox().height(this.getMinHeight());
                    window.scrollTo(0, this.getTextBox().offset().top);
                }
                else {
                    this.getTextBox().height(this.getHeight());
                }

                showMoreAbout
                    .find('.show-more-text')
                    .toggleClass('d-none');

                this.setVisibility(!this.getIsVisible());
            });
    }
}
